export default __webpack_public_path__ + "static/media/404-image.6e91a0a9.png";